import React, { useMemo } from 'react';
import { bubbleImageSrc } from '@/lib/bubbleImage';

const STARS = Array.from({ length: 60 }, (_, i) => ({
  left: (i * 37) % 100, top: (i * 53) % 70, size: (i % 3) + 1, delay: (i % 7) * 0.6,
}));

export const HomeSky = ({ others = [], away }) => {
  const drifters = useMemo(() => others.map((b, i) => ({
    ...b, top: 8 + ((i * 23) % 50), dur: 38 + (i % 4) * 12, delay: -i * 7, size: 22 + (i % 3) * 10,
  })), [others]);

  return (
    <div className="home-sky absolute inset-0 overflow-hidden pointer-events-none" data-testid="home-sky">
      <div className="absolute inset-0 home-aurora" />
      {STARS.map((s, i) => (
        <span key={i} className="absolute rounded-full bg-white home-twinkle"
              style={{ left: `${s.left}%`, top: `${s.top}%`, width: s.size, height: s.size, animationDelay: `${s.delay}s` }} />
      ))}
      {drifters.map((b) => (
        <div key={b.id} className="absolute home-drift" title={b.name}
             style={{ top: `${b.top}%`, animationDuration: `${b.dur}s`, animationDelay: `${b.delay}s` }}>
          <img src={bubbleImageSrc(b)} alt="" className="rounded-full opacity-70"
               style={{ width: b.size, height: b.size, filter: 'blur(0.4px)' }} />
        </div>
      ))}
      {away && <div className="absolute left-1/2 top-[12%] h-2 w-2 rounded-full bg-bx-cyan home-trail" data-testid="home-sky-away-dot" />}
      <div className="absolute bottom-0 inset-x-0 h-40 home-horizon" />
    </div>
  );
};

export default HomeSky;
